export * from '@fhs/routing/src/routes/store-locator/store/[idOrNumber]';
export { default } from '@fhs/routing/src/routes/store-locator/store/[idOrNumber]';
